export default __webpack_public_path__ + "static/media/Microsoft.c945ca84.png";